import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { SignalRConnectivityType, SignalRHubService } from '../../services/signalR.hub.service';
import { Tooltip, TooltipModule } from 'primeng/tooltip';
import { SignalRStatusVisibilityService } from './signalr-status-visibility.service';

@Component({
  selector: 'app-signalr-status',
  standalone: true,
  imports: [CommonModule, TooltipModule],
  template: `
    <span
      *ngIf="visible"
      tabindex="0"
      class="dot pointer"
      pTooltip="{{ 'Secure data ' + status | titlecase }}"
      [tooltipEvent]="tooltipTrigger"
      [tooltipPosition]="'bottom'"
      (click)="onDotClick()"
      [ngClass]="{
        'bg-green-500': status === 'available',
        'bg-yellow-500': status === 'reconnecting',
        'bg-red-500': status === 'not available'
      }"
    ></span>
  `,
  styles: [`
    .dot {
      display: inline-block;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      margin-left: 4px;
    }
  `],
  host: {
    class: 'flex',
  }
})
export class SignalrStatusComponent implements OnInit, OnDestroy {
  private signalRService = inject(SignalRHubService);
  private visibilityService = inject(SignalRStatusVisibilityService);
  private sub: Subscription[] = [];
  @ViewChild(Tooltip) tooltip!: Tooltip;
  status: 'available' | 'not available' | 'reconnecting' = 'not available';
  visible = false;
  tooltipTrigger: 'hover' | 'focus' = 'hover';

  ngOnInit(): void {
    this.tooltipTrigger = window.matchMedia('(hover: none) and (pointer: coarse)').matches ? 'focus' : 'hover';
    this.sub.push(
      this.signalRService.$events.subscribe(event => {
        switch (event) {
          case SignalRConnectivityType.Connected:
          case SignalRConnectivityType.Reconnected:
            this.status = 'available';
            break;
          case SignalRConnectivityType.Reconnecting:
            this.status = 'reconnecting';
            break;
          case SignalRConnectivityType.Disconnected:
          default:
            this.status = 'not available';
            break;
        }
      }),
      this.visibilityService.visible$.subscribe(visible => {
        this.visible = visible;
      })
    );
  }

  onDotClick() {
    if (this.tooltipTrigger === 'focus') {
      this.tooltip.activate();
    }
  }


  ngOnDestroy(): void {
    this.sub.forEach(s => s.unsubscribe());
  }
}